// extracted by mini-css-extract-plugin
export default {"wrapper":"Signup_wrapper__njShZ","container":"Signup_container__esTEJ"};